<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5">
  <loading v-if="loadingState" />
  <div v-if="!hideData && !orderRemoved" class="container pt-4 mt-5 pb-5">

    <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <div class="row justify-content-center text-left">
      <h3 class="Regular center h0 widthFull"><b>Pratica N. {{item.code}}</b></h3>

      <div class="col-md-8 pt-md-4 ">
        <h5 class="Regular h0 widthFull">Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni</b></h5>
        <p class="black mt-0 widthFull">
          Completa il form qui sotto.
          I dati inseriti verranno poi utilizzati per inviare la pratica Enea.
        </p>
      </div>
      <div class="col-md-4 pt-md-4 mt-3 center mb-3 text-right">
        <router-link :to="{ name: 'pratiche'}" class="btn btn-primary m-2 btn-sm ml-md-5">
          <font-awesome-icon icon="arrow-left" size="1x" />
          Indietro
        </router-link>
      </div>

    </div>

    <form class="pb-5 pt-4  black vaillantCont widthFull" id="registration-form">

      <!-- DATI ANAGRAFICI => ONLY PARTITA IVA + CONDOMONIO -->
      <div class="row justify-content-center pb-5 ">

        <!-- PERSONA FISICA    ******************************************************************************************************** -->
        <template v-if="item.client_type == 'Persona fisica'">
          <div class="col-md-12">
            <h4 v-if="item.client_type == 'Partita IVA'" class="widthFull center black">
              Completa i dati del cliente finale (<b>{{item.client_name}} {{item.client_lastname}}</b>)
            </h4>
          </div>
          <div class="col-md-4 mb-3" style="opacity: 1;">
            <div class="group custInput">
              <select type="text" autocomplete="randomq" class="form-control" v-model="client_ownership" id="client_ownership" name="client_ownership" data-vv-as="Titolo di possesso" v-validate="{required:true, max: 63, min: 2}"
                :class="{ 'is-invalid': errors.has('client_ownership'), valid: !!client_ownership }">
                <option value="Proprietario">Proprietario</option>
                <option value="Usufruttuario">Usufruttuario</option>
                <option value="Locatario">Locatario</option>
                <option value="Promissario acquirente">Promissario acquirente</option>
                <option value="Familiare convivente del possessore/detentore">Familiare convivente del possessore/detentore</option>
                <option value="Erede">Erede</option>
                <option value="Coniuge separato assegnatario">Coniuge separato assegnatario</option>
                <option value="Socio di cooperativa a proprietà indivisa">Socio di cooperativa a proprietà indivisa</option>
                <option value="Socio di cooperativa a proprietà divisa">Socio di cooperativa a proprietà divisa</option>
              </select>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="client_ownership">Titolo di possesso *</label>
              <div v-if="errors.has('client_ownership')" class="invalid-feedback">
                {{ errors.first("client_ownership") }}
              </div>
            </div>
          </div>
        </template>
        <!-- END PERSONA FISICA    ******************************************************************************************************** -->

        <!-- PARTITA IVA   ******************************************************************************************************** -->
        <template v-if="item.client_type == 'Partita IVA'">
          <div class="col-md-12">
            <h4 v-if="item.client_type == 'Partita IVA'" class="widthFull center black">
              Completa i dati del cliente finale (<b>{{item.client_name}} {{item.client_lastname}}</b>)
            </h4>
          </div>
          <!-- CLIENT Ragione sociale -->
          <div class="col-md-4">
            <div class="group custInput">
              <input type="text" class="form-control" v-model="azienda" id="azienda" name="azienda" data-vv-as="Ragione sociale" v-validate="{required:true, max: 128, min: 3}" :class="{ 'is-invalid': errors.has('azienda'), valid: !!azienda }">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="azienda">Ragione sociale * </label>
              <div v-if="errors.has('azienda')" class="invalid-feedback">
                {{ errors.first("azienda") }}
              </div>
            </div>
          </div>
          <!-- CLIENT Partita IVA -->
          <div class="col-md-4">
            <div class="group custInput">
              <input type="text" class="form-control" v-model="partita_iva" id="partita_iva" name="partita_iva" data-vv-as="Partita IVA" v-validate="{required: true, partitaIva: true, max: 11, min: 11,}"
                :class="{ 'is-invalid': errors.has('partita_iva'), valid: !!partita_iva }">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="partita_iva">Partita IVA *</label>

              <div v-if="errors.has('partita_iva')" class="invalid-feedback">
                {{ errors.first("partita_iva") }}
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-3" style="opacity: 1;">
            <div class="group custInput">
              <select type="text" autocomplete="randomq" class="form-control" v-model="client_ownership" id="client_ownership" name="client_ownership" data-vv-as="Titolo di possesso" v-validate="{required:true, max: 63, min: 2}"
                :class="{ 'is-invalid': errors.has('client_ownership'), valid: !!client_ownership }">
                <option value="Proprietario">Proprietario</option>
                <option value="Usufruttuario">Usufruttuario</option>
                <option value="Locatario">Locatario</option>
                <option value="Promissario acquirente">Promissario acquirente</option>
                <option value="Familiare convivente del possessore/detentore">Familiare convivente del possessore/detentore</option>
                <option value="Erede">Erede</option>
                <option value="Coniuge separato assegnatario">Coniuge separato assegnatario</option>
                <option value="Socio di cooperativa a proprietà indivisa">Socio di cooperativa a proprietà indivisa</option>
                <option value="Socio di cooperativa a proprietà divisa">Socio di cooperativa a proprietà divisa</option>
              </select>
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="client_ownership">Titolo di possesso *</label>
              <div v-if="errors.has('client_ownership')" class="invalid-feedback">
                {{ errors.first("client_ownership") }}
              </div>
            </div>
          </div>

          <h4 class="widthFull center black">
            Sede Legale
          </h4>

          <div class="col-md-4 mb-3">
            <div class="group custInput">
              <input type="text" autocomplete="randomr" class="form-control" v-model="address" id="address" name="address" data-vv-as="Indirizzo" v-validate="{required:true, max: 128, min: 5}"
                :class="{ 'is-invalid': errors.has('address'), valid: !!address }">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="address">Indirizzo *</label>
              <div v-if="errors.has('address')" class="invalid-feedback">
                {{ errors.first("address") }}
              </div>
            </div>
          </div>
          <div class="col-md-2 mb-3">
            <div class="group custInput">
              <input type="text" autocomplete="randomt" class="form-control" v-model="civic" id="civic" name="civic" data-vv-as="Civico" v-validate="{required:true, max: 15}" :class="{ 'is-invalid': errors.has('civic'), valid: !!civic }">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="civic">Civico *</label>
              <div v-if="errors.has('civic')" class="invalid-feedback">
                {{ errors.first("civic") }}
              </div>
            </div>
          </div>

          <div class="col-md-2 mb-3">
            <div class="group custInput">
              <input type="text" autocomplete="randomt" class="form-control" v-model="cap" id="cap" name="cap" data-vv-as="Cap" v-validate="{required:true, min: 5, max: 6}" :class="{ 'is-invalid': errors.has('cap'), valid: !!cap }">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="cap">Cap *</label>
              <div v-if="errors.has('cap')" class="invalid-feedback">
                {{ errors.first("cap") }}
              </div>
            </div>
          </div>



        </template>
        <!-- END PARTITA IVA   ******************************************************************************************************** -->



        <!-- CONDOMINIO  ********************************************************************************************************  -->
        <template v-if="item.client_type == 'Amministratore di condominio'">
          <div class="col-md-12">
            <h4 class="widthFull center black">
              Completa i dati dell'Amministratore del condominio (<b>{{item.client_name}} {{item.client_lastname}}</b>)
            </h4>
          </div>

          <div class="col-md-6 mb-3">
            <div class="group custInput">
              <input type="text" autocomplete="randomt" class="form-control" v-model="quantHouses" id="quantHouses" name="quantHouses" data-vv-as="Numero di unità immobiliari" v-validate="{required:true, min: 1, max: 6}"
                :class="{ 'is-invalid': errors.has('quantHouses'), valid: !!quantHouses }">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="quantHouses">Numero di unità immobiliari che compongono l’edificio *</label>
              <div v-if="errors.has('quantHouses')" class="invalid-feedback">
                {{ errors.first("quantHouses") }}
              </div>
            </div>
          </div>

        </template>
        <!-- END CONDOMINIO  ******************************************************************************************************** -->


        <!-- TITLE ROW 1 HOUSE INFO -->
        <div class="col-md-12">
          <h4 class="widthFull center black">
            Inserisci i dati dell'intervento
          </h4>
        </div>

        <div class="col-md-4 mb-3 ">
          <div class="group custInput">
            <datepicker :language="it" v-model="eventStartdate" :full-month-name="true" :format="'dd MMMM yyyy'" :monday-first="true" :disabledDates="disabledDatesStart" id="eventStartdate" name="eventStartdate" input-class="form-control dateInput">
            </datepicker>
            <input type="text" v-show="false" v-model="eventStartdate" class="form-control" id="eventStartdate" name="eventStartdate" data-vv-as="Data inizio" v-validate="{required:true}"
              :class="{ 'is-invalid': errors.has('eventStartdate'), valid: !!eventStartdate }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="eventStartdate">Data inizio</label>
            <div v-if="errors.has('eventStartdate')" class="invalid-feedback">
              {{ errors.first("eventStartdate") }}
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3 ">
          <div class="group custInput">
            <datepicker :language="it" v-model="eventEndtdate" :full-month-name="true" :format="'dd MMMM yyyy'" :monday-first="true" :disabledDates="disabledDatesStart" id="eventEndtdate" name="eventEndtdate" input-class="form-control dateInput">
            </datepicker>
            <input type="text" v-show="false" v-model="eventEndtdate" class="form-control" id="eventEndtdate" name="eventEndtdate" data-vv-as="Data ultimazione dei lavori" v-validate="{required:true}"
              :class="{ 'is-invalid': errors.has('eventEndtdate'), valid: !!eventEndtdate }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <label class="niceInputLabel" for="eventEndtdate">Data ultimazione dei lavori (collaudo)</label>
            <div v-if="errors.has('eventEndtdate')" class="invalid-feedback">
              {{ errors.first("eventEndtdate") }}
            </div>
          </div>
        </div>


        <!-- TITLE ROW 1 HOUSE INFO -->
        <template v-if="item.bonus != 'Bonus Casa 50%'">

          <div class="col-md-12">
            <h4 class="widthFull center black">
              Scheda tecnica delle valvole termostatiche
            </h4>

          </div>

          <div class="col-md-8 mb-3 pr-4 text-left">
            <div class="form-check">
              <div class="p-3">
                <input class="form-check-input" type="checkbox" v-model="noValvole" id="noValvole" name="noValvole" data-vv-as="" v-validate="{}" :class="{ 'is-invalid': errors.has('noValvole') }">
                <label class="form-check-label textStable" for="noValvole">
                  <b>Valvole termostatiche non installate come da relazione allegata alla Dichiarazione di Conformità.
                  <br/>Se questo campo viene valorizzato il documento richiesto può essere omesso.</b>
                </label>
                <div v-if="errors.has('noValvole')" class="invalid-feedback">
                  {{ errors.first("noValvole") }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="!noValvole" class="col-md-12 mb-4">

            <p class="center">Se necessario è possibile selezionare piu di un file</p>

            <div class="front-image">

              <input type="file" v-on:change="uploadFile" ref="fileInput" multiple name="invoiceFront" id="invoiceFront" class="fileInput" data-vv-as="Scheda tecnica delle valvole termostatiche"
                v-validate="{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                :class="{ 'is-invalid': errors.has('invoiceFront'), valid: !!invoiceFront, helper: !!invoiceFrontBucket }">

              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel labelFileInput" for="invoiceFront">

                <span v-if="!invoiceFrontName" class="smallText center white" :style="{ backgroundImage: 'url(' + invoiceFrontBucket + ')' }">
                  <p v-if="!invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0">Scegli il Contratto quadro*</p>
                </span>

                <span v-else class="smallText center white" :style="{  backgroundImage: 'url(' + invoiceFrontBucket + ')' }">

                </span>

              </label>

              <div v-if="errors.has('invoiceFront')" class="invalid-feedback" style="top:185px">
                {{ errors.first('invoiceFront') }}
              </div>

              <div v-if="uploadFrontPercentage" class="progress mt-5" id="progFront">
                <div class="progress-bar " id="progress-bar-front" role="progressbar" v-bind:style="{width: uploadFrontPercentage + '%'}" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                  {{ uploadFrontPercentage }} %
                </div>
              </div>

              <p v-if="invoiceFrontName" class="smallText center white mt-3 mb-0 pb-0 fileNameText">{{invoiceFrontName}}</p>

            </div>


          </div>

        </template>


        <div class="col-md-12 mb-3 center mt-5">
          <button class="btn btn-primary" type="button" v-on:click="setAditionalEneaData"> Salva </button>
        </div>

      </div>


    </form>


  </div>





</div>

</div>
</template>

<script>
import {
  USER_REQUEST
} from 'actions/user'

import {
  AUTH_REQUEST,
  AUTH_SOCIAL,
  SET_USER_TOKEN
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import {
  ADD_NOTIFICATIONS,
  GET_NOTIFICATIONS
} from 'actions/notifications'

import Datepicker from 'vuejs-datepicker'
import {
  it
} from 'vuejs-datepicker/dist/locale'

import axios from 'axios'

const moment = require('moment')

export default {
  name: 'acceptInvoice',
  components: {
    Datepicker
  },
  data() {
    return {
      token: '',
      loadingState: false,
      loading: false,
      eventEndtdate: '',
      it: it,
      eventStartdate: '',
      practices: {},
      moment: require('moment'),
      item: {},
      hideData: false,
      email: '',
      codice_fiscale: '',
      partita_iva: '',
      phone: '',
      mobile: '',
      cellulare: '',
      address: '',
      civic: '',
      azienda: '',
      region: '',
      province: '',
      city: '',
      cap: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      client_ownership: '',
      subalterno: '',
      particella: '',
      foglio: '',
      fromQRcode: false,
      tokenControl: false,
      passwordControl: false,
      orderRemoved: false,
      quantHouses: '',
      disabledDatesStart: {
        to: '',
        from: ''
      },
      noValvole: false,
    }
  },
  methods: {
    setAditionalEneaData: function() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loadingState = true

          var data = {
            aditional_enea_data: {
              company: this.azienda,
              partita_iva: this.partita_iva,
              client_ownership: this.client_ownership,
              company_address: this.address,
              company_civic: this.civic,
              company_zip: this.cap,
              intervention_start_date: moment(this.eventStartdate).format('DD-MM-YYYY'),
              intervention_end_date: moment(this.eventEndtdate).format('DD-MM-YYYY'),
              house_quantity: this.quantHouses,
              valvole_doc: this.invoiceFrontBucket
            },
            user_token: this.getProfile.userToken,
            code: this.item.code

          }

          this.$log(data)
          axios({
              url: process.env.ROOT_API + 'api/addAdditionalEneaData',
              method: 'POST',
              data: data,
              headers: {
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
                'Content-type': 'application/json'
              }
            })
            .then(resp => {
              this.loadingState = false
              this.addSuccess()
              this.$router.push('/pratiche')
            })
            .catch(resp => {
              this.loadingState = false
              this.showAlert()
            })

          //



        } else {
          this.$scrollTo('#app', 700, {
            offset: -75
          })
        }
      })
    },
    uploadFile: function(input) {
      var file = input.target.files[0].name
      this.invoiceFrontName = file
      var extension = file.substr((file.lastIndexOf('.') + 1)).toLowerCase()
      var size = input.target.files[0].size


      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name
        var formData = new FormData();
        var _vue = this // << here
        var t = 0
        for ( var x in input.target.files ){
          formData.append('fattura' + t, input.target.files[x]);
          t = t + 1
        }

        axios.post(process.env.ROOT_API + 'api/uploadImageInvoice',
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              },
              onUploadProgress: function(progressEvent) {
                this.uploadFrontPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
              }.bind(this)
            }
          ).then(function(e) {
            var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
            if (regex.test(e.data.fattura)) {
              _vue.uploadFrontPercentage = 0
              _vue.invoiceFrontBucket = e.data.fattura
            } else {
              _vue.uploadFrontPercentage = 0
              _vue.invoiceFront = ''
              _vue.invoiceFrontBucket = ''
              _vue.UploadError()
              input.target.value = null
            }

          })
          .catch(function() {
            _vue.uploadFrontPercentage = 0
            _vue.invoiceFront = ''
            _vue.invoiceFrontBucket = ''
            _vue.UploadError()
            input.target.value = null

          });
      }

    },
    addSuccess() {
      this.$swal({
        type: 'success',
        title: '<strong class="modalText ">I tuoi dati sono state salvati correttamente.</strong>',
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267',
      });
    },
    populateProvincies: function() {
      const {
        provincies,
        provinciesState
      } = this
      axios({
          url: process.env.ROOT_API + 'api/getProvinciesAll',
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          this.provincies = resp.data.provincies;
          this.provinciesState = false

        })
        .catch(resp => {
          this.provincies = [];
          this.provinciesState = false
        })
    },

    async getPracticById(userToken, id) {
      this.$log('GET PRACTIC FOR QRcode ENTER')
      await axios({
          url: process.env.ROOT_API + 'api/getPracticById',
          method: 'POST',
          data: {
            'user_token': userToken,
            'id': id
          },
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          this.$log('GET PRACTIC FOR QRcode => OK')
          // CHECK IF ACTIVE YET

          this.$route.params.item = resp.data.practices[0]

          // MENU OFF FOR THIS CASE
          var alert = {}
          alert.text = 'NOT LOGED VIEW'
          alert.type = 'MENU_OFF'
          //this.$store.dispatch(ADD_NOTIFICATIONS, alert)

        })
        .catch(resp => {
          this.$log('GET PRACTIC FOR QRcode => ERROR')
          this.tokenControl = false
        })
    },
    checkProvince: function() {

      const {
        province
      } = this
      if (province) {
        this.cityError = false
      } else {
        this.cityError = true
      }

    },
    checkZip: function() {
      const {
        city
      } = this
      if (city) {
        this.zipError = false
      } else {
        this.zipError = true
      }
    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Riprova più tardi!',
      });
    },
    async setCap(cap) {
      for (var x in this.zips) {
        if (this.zips[x].cap == cap.toUpperCase()) {
          this.zip = this.zips[x].cap
        }
      }

    },
    async setCity(city) {

      for (var x in this.cities) {
        if (this.cities[x].comune == city.toUpperCase()) {
          var k = {
            cityistat: this.cities[x].istat,
            city: city.toUpperCase(),
          }
          this.city = k
        }
      }
      this.$log(this.city)

    },
    async setProvince(province) {

      for (var x in this.provincies) {
        if (this.provincies[x].sigla == province.toUpperCase()) {
          this.province = this.provincies[x].sigla
        }
      }

    },
    calcToDateStart() {
      var date = new Date(2021, 0, 1)
      var finalTo = date

      this.$log(finalTo)
      return finalTo
    },
    calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000))
      var finalTo = date
      return finalTo
    },
  },
  watch: {
    adress: function(val) {
      if (val) {
        this.adress = this.adress.toUpperCase()
      }
    },
    civic: function(val) {
      if (val) {
        this.civic = this.civic.toUpperCase()
      }
    },
    phone: function(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, '');
      }
    },
    mobile: function(val) {
      if (val) {
        this.mobile = val.replace(/\D+/g, '');
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function(newProvince) {
      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = ''
      this.cityError = false
      this.zipError = false

      if (newProvince) {
        this.citiesState = true
        axios({
            url: process.env.ROOT_API + 'api/getComuni',
            method: 'POST',
            data: {
              provincia: newProvince
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            this.cities = resp.data.cities
            this.citiesState = false
          })
          .catch(resp => {
            this.cities = [];
            this.citiesState = false
          })
      }

    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function(newCity) {
      this.zipError = false
      this.zips = [];
      this.zip = '';

      if (newCity.cityistat) {
        this.zipsState = true
        axios({
            url: process.env.ROOT_API + 'api/getCap',
            method: 'POST',
            data: {
              istat: newCity.cityistat
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            this.zips = resp.data.zips;
            this.zipsState = false
          })
          .catch(resp => {
            this.zips = [];
            this.zipsState = false
          })
      }

    },
  },
  created() {

  },
  async mounted() {

    if (this.$route.params.item) {
      this.item = this.$route.params.item

    } else {
      if (!this.tokenControl) {
        this.$router.push('/pratiche')
      }
    }
    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart(), // Disable all dates after specific date
    }
    this.populateProvincies()



    this.$scrollTo('#app', 700, {
      offset: -75
    })


  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    })
  },
}
</script>

<style lang="scss" scoped>
$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;

.fileNameText {
    position: absolute;
    bottom: -37px;
    font-size: 17px;
    width: 100%;
    text-align: center;
    color: #0e3d8b!important;
    z-index: 12313;
    white-space: nowrap;
    word-wrap: break-word;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.borderTop {
    border-top: 3px solid #003d13;
    padding-top: 15px;
}

.shopIcon {
    width: 75px;
}

.bigTitle {
    font-size: 47px;
    color: #003d13;

    @media screen and (max-width: $phone) {
        font-size: 27px;
    }

}

.hideFileUpload {
    position: absolute;
    width: 100%;
    height: 110%;
    background: #000000;
    opacity: 0.4;
    top: -18px;
    left: 0;
    filter: blur(24px);
    z-index: 10000;
}

h5 {

    @media screen and (max-width: $phone) {
        font-size: 14px;
    }

}
.corporateImg {
    max-height: 153px;
}
.backImageInvoice {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
    > img {
        max-height: 477px;
        margin: 0 auto;
        cursor: pointer;
    }
}

.zoomImage {
    position: absolute;
    left: 48%;
    top: 230px;
    cursor: pointer;
}

.vcenter {
    align-items: center;
    align-self: center;
    vertical-align: middle;
    display: inherit;
}

.front-image {

    position: relative;
    margin: 0 auto;
    display: block;
    height: 177px;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    width: 191px;
    margin-bottom: 17px;

    @media screen and (max-width: $tablet) {
        margin-top: 15px!important;
    }

    > .fileInputLabel {
        display: none;
    }

    > .invalid-feedback {
        display: block;
        position: absolute;
        bottom: 15px;
        font-weight: 800;
    }

    > input {
        position: absolute;
        filter: alpha(opacity=0);
        opacity: 0;
        left: 5px;
        width: 100%;
        height: 200px;
        z-index: 10;
        top: -20px;
    }

    > label {
        /*display: none;*/

        width: 100%;
        margin: 0 auto;
        text-align: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-item-align: center;
        align-self: center;
        position: relative;
        padding: 0!important !important;
        left: 0;

        > span {
            background-color: transparent;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            border: none;
            width: 192px;
            margin-top: 19px !important;
            display: block;
            height: 155px;
            margin: 0 auto;
            cursor: pointer;
            word-break: break-all;
            padding: 5px;
            color: white;
            border-radius: 7px;
            overflow-wrap: break-word;
            white-space: normal;
            line-height: 29px;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            align-self: center;
            vertical-align: middle;
            margin: auto;
            display: inline-grid;
            background-size: cover;
            background-position: center;

            &:before {
                content: "+";
                display: block;
                clear: both;
                text-align: center;
                height: 141px;
                width: 179px;
                border-radius: 7px;
                padding-top: 51px;
                font-size: 51px;
                font-weight: 600;
                color: #00917e;
                border: 3px solid #00917e;
            }

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        &:after {
            content: "";
            display: block;

            clear: both;
            text-align: center;
            width: 237px;
            font-size: 10px;
            text-decoration: underline;
            color: black;

            /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

            @media screen and (max-width: $phone) {
                margin: 0 auto!important !important;
                float: none;
            }
            @media screen and (min-width: $phone) and (max-width: $tablet) {
                margin: 0 auto!important !important;
                float: none;
            }

        }

        @media screen and (max-width: $phone) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }
        @media screen and (min-width: $phone) and (max-width: $tablet) {
            width: 100%!important;
            float: none!important;
            text-align: center!important;
            margin: 0 auto!important !important;
        }

    }

}

.center-container {
    display: flex;
    align-items: center;
    flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/complateEneaData/index.vue